<template>
  <div class="thumbnail" :style="{ backgroundImage: thumbnailStyle }"></div>
</template>

<script>
import { mapState } from "vuex";
import appSettings from "./appSettings";

export default {
  name: "AppAssetThumbnail",
  components: {},
  props: {
    asset: {
      type: Object,
      default: Object.default,
    },
  },
  data: () => ({ thumbUrl: null, createdBlobUrl: null }),
  computed: {
    ...mapState(["idToken"]),
    thumbnailStyle() {
      return this.thumbUrl ? `url(${this.thumbUrl})` : "";
    },
  },
  mounted() {
    this.loadThumbnail();
  },
  beforeDestroy() {
    this.revokeObjectUrl();
  },
  methods: {
    async loadThumbnail() {
      if (!this.asset) return;

      this.loading = true;
      this.error = null;
      let thumbUrl = this.asset.metadata.thumb;

      if (!thumbUrl || thumbUrl.startsWith("http")) {
        // Icon or similar, no need to fetch
        this.thumbUrl = thumbUrl;
        return;
      }
      thumbUrl = `${appSettings.remoteurl}/api${thumbUrl}`;

      try {
        const response = await fetch(thumbUrl, {
          method: "GET",
          headers: {
            // Most APIs expect a Bearer token; change if yours uses a different scheme
            Authorization: `Bearer ${this.idToken}`,
          },
        });

        if (!response.ok) {
          throw new Error(
            `Thumbnail request failed (${response.status} ${response.statusText})`
          );
        }

        const blob = await response.blob();

        // Create a temporary URL that lives only in memory
        this.createdBlobUrl = URL.createObjectURL(blob);
        this.thumbUrl = this.createdBlobUrl;
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },

    /** Release the object‑URL when we no longer need it */
    revokeObjectUrl() {
      if (this.createdBlobUrl) {
        URL.revokeObjectURL(this.createdBlobUrl);
        this.createdBlobUrl = null;
      }
    },
  },
};
</script>
<style scoped>
.thumbnail {
  display: flex;
  margin: 20px 20px;
  align-items: center;
  justify-content: center;
  height: 22vh;
  width: 22vh;
  border-radius: 12px;
  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
}
</style>
